/* ============================================================
   Cathaya × Minimog — Predictive Search
   Attaches a dropdown to every <form class="c-search"> that has
   an <input name="q">. Queries /search/suggest.json on input
   (debounced), renders product / collection / page / article
   results in a Cathaya-styled panel.

   No markup edits required in header.liquid — this script
   discovers forms at DOMContentLoaded and on shopify:section:load.
   ============================================================ */

(function () {
  "use strict";

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var DEBOUNCE_MS = 220;
  var MIN_LEN = 2;
  var LIMIT = 6;

  // ---------- styles (one-shot inject) ----------

  var STYLE_ID = "cathaya-predictive-search-style";
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent =
      ".c-search.cps-host { position: relative; }" +
      ".cps-panel { position: absolute; top: calc(100% + 8px); left: 0; right: 0; z-index: 9000; background: #fffaf4; border: 1px solid rgba(33,23,22,0.08); border-radius: 8px; box-shadow: 0 12px 40px rgba(45,31,26,0.14); padding: 10px; max-height: 70vh; overflow-y: auto; display: none; }" +
      ".cps-panel.is-open { display: block; }" +
      ".cps-group { padding: 6px 4px; }" +
      ".cps-group + .cps-group { border-top: 1px solid rgba(33,23,22,0.06); margin-top: 6px; padding-top: 10px; }" +
      ".cps-group-title { font-size: 10px; font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; color: #b8734f; margin: 0 0 8px; padding: 0 4px; }" +
      ".cps-item { display: flex; align-items: center; gap: 12px; padding: 8px; border-radius: 6px; color: #211716; text-decoration: none; transition: background 0.15s ease; }" +
      ".cps-item:hover, .cps-item.is-active { background: #f8f3ee; color: #211716; }" +
      ".cps-thumb { flex: 0 0 44px; width: 44px; height: 44px; border-radius: 4px; overflow: hidden; background: #fbf7f2; }" +
      ".cps-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }" +
      ".cps-body { flex: 1; min-width: 0; }" +
      ".cps-title { font-size: 14px; font-weight: 600; line-height: 1.3; margin: 0 0 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }" +
      ".cps-price { font-size: 13px; font-weight: 700; color: #6d4335; }" +
      ".cps-price del { color: rgba(33,23,22,0.36); font-weight: 500; margin-right: 6px; }" +
      ".cps-link { font-size: 14px; }" +
      ".cps-empty, .cps-loading { padding: 18px 10px; text-align: center; font-size: 13px; color: rgba(33,23,22,0.56); }" +
      ".cps-viewall { display: block; text-align: center; padding: 10px; margin-top: 6px; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #b8734f; background: #f2dfda; border-radius: 6px; text-decoration: none; }" +
      ".cps-viewall:hover { background: #e8c98f; color: #211716; }";
    document.head.appendChild(s);
  }

  // ---------- helpers ----------

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c];
    });
  }

  function fmtMoney(cents) {
    if (cents == null) return "";
    if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
      try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {}
    }
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  // ---------- rendering ----------

  function renderResults(panel, data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var pages = r.pages || [];
    var articles = r.articles || [];

    if (!products.length && !collections.length && !pages.length && !articles.length) {
      panel.innerHTML = '<div class="cps-empty">No results for "' + escapeHtml(q) + '"</div>';
      return;
    }

    var html = "";
    if (products.length) {
      html += '<div class="cps-group"><p class="cps-group-title">Products</p>';
      products.forEach(function (p) {
        var img = p.featured_image && (p.featured_image.url || p.featured_image);
        var priceHtml = "";
        if (p.compare_at_price_min && p.compare_at_price_min > p.price_min) {
          priceHtml = "<del>" + fmtMoney(p.compare_at_price_min) + "</del>" + fmtMoney(p.price_min);
        } else {
          priceHtml = fmtMoney(p.price_min);
        }
        html +=
          '<a class="cps-item" href="' + escapeHtml(p.url) + '">' +
            '<div class="cps-thumb">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : "") + '</div>' +
            '<div class="cps-body">' +
              '<p class="cps-title">' + escapeHtml(p.title) + '</p>' +
              '<div class="cps-price">' + priceHtml + '</div>' +
            '</div>' +
          '</a>';
      });
      html += "</div>";
    }
    if (collections.length) {
      html += '<div class="cps-group"><p class="cps-group-title">Collections</p>';
      collections.forEach(function (c) {
        html += '<a class="cps-item cps-link" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a>';
      });
      html += "</div>";
    }
    if (pages.length) {
      html += '<div class="cps-group"><p class="cps-group-title">Pages</p>';
      pages.forEach(function (p) {
        html += '<a class="cps-item cps-link" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>';
      });
      html += "</div>";
    }
    if (articles.length) {
      html += '<div class="cps-group"><p class="cps-group-title">Articles</p>';
      articles.forEach(function (a) {
        html += '<a class="cps-item cps-link" href="' + escapeHtml(a.url) + '">' + escapeHtml(a.title) + '</a>';
      });
      html += "</div>";
    }
    html += '<a class="cps-viewall" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '">View all results</a>';
    panel.innerHTML = html;
  }

  // ---------- attach to one form ----------

  function attach(form) {
    if (form.dataset.cpsBound === "true") return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.dataset.cpsBound = "true";
    form.classList.add("cps-host");

    var panel = document.createElement("div");
    panel.className = "cps-panel";
    form.appendChild(panel);

    function close() { panel.classList.remove("is-open"); }
    function open()  { panel.classList.add("is-open"); }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN_LEN) { close(); return; }
      panel.innerHTML = '<div class="cps-loading">Searching…</div>';
      open();
      var url = ROOT + "search/suggest.json"
        + "?q=" + encodeURIComponent(q)
        + "&resources[type]=product,collection,page,article"
        + "&resources[limit]=" + LIMIT
        + "&resources[options][unavailable_products]=last";
      fetch(url, { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderResults(panel, data, q); })
        .catch(function (e) {
          console.warn("[cathaya-predictive-search] fetch failed", e);
          panel.innerHTML = '<div class="cps-empty">Search unavailable. Try Enter.</div>';
        });
    }, DEBOUNCE_MS);

    input.addEventListener("input", run);
    input.addEventListener("focus", function () {
      if (input.value.trim().length >= MIN_LEN) open();
    });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) close();
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { close(); input.blur(); }
    });
  }

  function attachAll(root) {
    root = root || document;
    root.querySelectorAll("form.c-search").forEach(attach);
  }

  // ---------- init ----------

  function init() {
    injectStyles();
    attachAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", function (e) { attachAll(e.target); });
})();
